/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Overlay_MoreInputs */

const en_us2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More options`)
};

const pt_br2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais opções`)
};

const es_419_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más opciones`)
};

const pt_pt2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais opções`)
};

const fr_fr2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d'options`)
};

const de_de2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Optionen`)
};

const it_it2_ui_overlay_more = /** @type {(inputs: Ui_Overlay_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre opzioni`)
};

/**
* | output |
* | --- |
* | "More options" |
*
* @param {Ui_Overlay_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_overlay_more = /** @type {((inputs?: Ui_Overlay_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Overlay_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_overlay_more(inputs)
	if (locale === "es-419") return es_419_ui_overlay_more(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_overlay_more(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_overlay_more(inputs)
	if (locale === "de-DE") return de_de2_ui_overlay_more(inputs)
	if (locale === "it-IT") return it_it2_ui_overlay_more(inputs)
	return en_us2_ui_overlay_more(inputs)
});
export { ui_overlay_more as "ui-overlay.more" }